export default __webpack_public_path__ + "static/media/cif-na.ad61a74e.svg";